import { observer } from 'mobx-react';
import * as React from 'react';
import { Icon, Text } from '@doordash/design-language';
import CartItem from 'models/CartItem';
import SharedCartItem from 'models/SharedCartItem';
import MenuItem from 'models/MenuItem';
import Cart from 'models/Cart';
import { Plus } from 'assets/custom-icons';
import { CartIconWrapper, IconButton, IconWrapper, StepperIconWrapper, StepperWrapper } from './recommendationStyles';
import { addItemToCart, handleDecreaseQty, handleIncreaseQty, removeItemFromCart } from './utils';

interface BaseStepperType {
  itemId: string;
  selectedCart: Cart;
  fromCart: boolean;
  adjustPadding: boolean;
  setVisible: (visible: boolean) => void;
  referringItem?: MenuItem;
  existingCartItem?: CartItem | SharedCartItem;
  quantity?: number;
}

type StepperWithItemInCart = BaseStepperType & {
  itemInCart: true;
  pushCartItem?: (newCartItem: CartItem | SharedCartItem) => void;
  newCartItem?: CartItem | SharedCartItem;
};

type StepperWithoutItemInCart = BaseStepperType & {
  itemInCart: false;
  pushCartItem: (newCartItem: CartItem | SharedCartItem) => void;
  newCartItem: CartItem | SharedCartItem;
};

type StepperType = StepperWithItemInCart | StepperWithoutItemInCart;

function Stepper({
  existingCartItem,
  pushCartItem,
  itemId,
  newCartItem,
  itemInCart,
  selectedCart,
  referringItem,
  fromCart,
  setVisible,
  quantity,
  adjustPadding,
}: StepperType) {
  const {
    Sizes: { Medium },
  } = Icon;
  const cartItem = existingCartItem ?? selectedCart?.items.find((item) => item.menu_item_id === itemId);
  React.useEffect(() => {}, [cartItem?.qty]);
  const itemList = document.getElementById('cart-items-list');
  const Wrapper = adjustPadding ? CartIconWrapper : IconWrapper;

  return itemInCart ? (
    <Wrapper>
      <StepperWrapper>
        {cartItem && cartItem.qty > 1 ? (
          <StepperIconWrapper>
            <Icon
              onClick={() =>
                handleDecreaseQty({ setAppliedLoyaltyRewards: selectedCart.setAppliedLoyaltyRewards, cartItem })
              }
              size={Medium}
              type={Icon.Types.Subtract}
            />
          </StepperIconWrapper>
        ) : (
          <StepperIconWrapper>
            <Icon
              onClick={() => removeItemFromCart(selectedCart, cartItem)}
              size={Medium}
              type={Icon.Types.TrashLine}
            />
          </StepperIconWrapper>
        )}
        <Text styles={Text.Styles.Bold14}>{quantity ?? cartItem?.qty}</Text>
        <StepperIconWrapper>
          <Icon
            onClick={() =>
              handleIncreaseQty({ setAppliedLoyaltyRewards: selectedCart.setAppliedLoyaltyRewards, cartItem })
            }
            size={Medium}
            type={Icon.Types.Add}
          />
        </StepperIconWrapper>
      </StepperWrapper>
    </Wrapper>
  ) : (
    <Wrapper
      onClick={() => {
        if (newCartItem.hasMods()) {
          pushCartItem(newCartItem);
        } else {
          addItemToCart(itemId, selectedCart, newCartItem, referringItem);
        }
        if (fromCart) {
          setTimeout(() => {
            itemList?.scrollIntoView(false);
            setVisible(false);
          }, 400);
        }
      }}
    >
      <IconButton>
        <Plus />
      </IconButton>
    </Wrapper>
  );
}

export default observer(Stepper);
